export default "__VITE_ASSET__BZLASwa4__"